// Auto-generated list of countries with ISO-3166 alpha-2 code, international
// dialing code, and the expected national significant number length (digits
// after the country code, excluding the leading '+' and dial code itself).
//
// Source data derived from ITU/E.164 national numbering plans. A handful of
// small territories without a published format fall back to their parent
// numbering plan's typical length.
export interface CountryPhoneInfo {
  name: string;
  iso2: string;   // ISO 3166-1 alpha-2, used to derive the flag emoji
  dialCode: string; // without the leading '+'
  digits: number;   // expected national number length
}

export const COUNTRIES: CountryPhoneInfo[] = [
  { name: "Afghanistan", iso2: "AF", dialCode: "93", digits: 9 },
  { name: "Albania", iso2: "AL", dialCode: "355", digits: 9 },
  { name: "Algeria", iso2: "DZ", dialCode: "213", digits: 9 },
  { name: "American Samoa", iso2: "AS", dialCode: "1684", digits: 7 },
  { name: "Andorra", iso2: "AD", dialCode: "376", digits: 6 },
  { name: "Angola", iso2: "AO", dialCode: "244", digits: 9 },
  { name: "Anguilla", iso2: "AI", dialCode: "1264", digits: 7 },
  { name: "Antarctica", iso2: "AQ", dialCode: "672", digits: 6 },
  { name: "Antigua and Barbuda", iso2: "AG", dialCode: "1268", digits: 7 },
  { name: "Argentina", iso2: "AR", dialCode: "54", digits: 10 },
  { name: "Armenia", iso2: "AM", dialCode: "374", digits: 8 },
  { name: "Aruba", iso2: "AW", dialCode: "297", digits: 7 },
  { name: "Australia", iso2: "AU", dialCode: "61", digits: 9 },
  { name: "Austria", iso2: "AT", dialCode: "43", digits: 10 },
  { name: "Azerbaijan", iso2: "AZ", dialCode: "994", digits: 9 },
  { name: "Bahamas", iso2: "BS", dialCode: "1242", digits: 7 },
  { name: "Bahrain", iso2: "BH", dialCode: "973", digits: 8 },
  { name: "Bangladesh", iso2: "BD", dialCode: "880", digits: 8 },
  { name: "Barbados", iso2: "BB", dialCode: "1246", digits: 7 },
  { name: "Belarus", iso2: "BY", dialCode: "375", digits: 9 },
  { name: "Belgium", iso2: "BE", dialCode: "32", digits: 9 },
  { name: "Belize", iso2: "BZ", dialCode: "501", digits: 7 },
  { name: "Benin", iso2: "BJ", dialCode: "229", digits: 8 },
  { name: "Bermuda", iso2: "BM", dialCode: "1441", digits: 7 },
  { name: "Bhutan", iso2: "BT", dialCode: "975", digits: 7 },
  { name: "Bolivia", iso2: "BO", dialCode: "591", digits: 8 },
  { name: "Bosnia and Herzegovina", iso2: "BA", dialCode: "387", digits: 6 },
  { name: "Botswana", iso2: "BW", dialCode: "267", digits: 8 },
  { name: "Bouvet Island", iso2: "BV", dialCode: "47", digits: 8 },
  { name: "Brazil", iso2: "BR", dialCode: "55", digits: 10 },
  { name: "British Indian Ocean Territory", iso2: "IO", dialCode: "246", digits: 7 },
  { name: "British Virgin Islands", iso2: "VG", dialCode: "1284", digits: 7 },
  { name: "Brunei", iso2: "BN", dialCode: "673", digits: 7 },
  { name: "Bulgaria", iso2: "BG", dialCode: "359", digits: 9 },
  { name: "Burkina Faso", iso2: "BF", dialCode: "226", digits: 8 },
  { name: "Burundi", iso2: "BI", dialCode: "257", digits: 8 },
  { name: "Cambodia", iso2: "KH", dialCode: "855", digits: 8 },
  { name: "Cameroon", iso2: "CM", dialCode: "237", digits: 8 },
  { name: "Canada", iso2: "CA", dialCode: "1", digits: 10 },
  { name: "Cape Verde", iso2: "CV", dialCode: "238", digits: 7 },
  { name: "Caribbean Netherlands", iso2: "BQ", dialCode: "599", digits: 7 },
  { name: "Cayman Islands", iso2: "KY", dialCode: "1345", digits: 7 },
  { name: "Central African Republic", iso2: "CF", dialCode: "236", digits: 8 },
  { name: "Chad", iso2: "TD", dialCode: "235", digits: 8 },
  { name: "Chile", iso2: "CL", dialCode: "56", digits: 9 },
  { name: "China", iso2: "CN", dialCode: "86", digits: 10 },
  { name: "Christmas Island", iso2: "CX", dialCode: "61", digits: 9 },
  { name: "Cocos", iso2: "CC", dialCode: "61", digits: 9 },
  { name: "Colombia", iso2: "CO", dialCode: "57", digits: 10 },
  { name: "Comoros", iso2: "KM", dialCode: "269", digits: 7 },
  { name: "Congo", iso2: "CD", dialCode: "243", digits: 9 },
  { name: "Congo", iso2: "CG", dialCode: "242", digits: 9 },
  { name: "Cook Islands", iso2: "CK", dialCode: "682", digits: 5 },
  { name: "Costa Rica", iso2: "CR", dialCode: "506", digits: 8 },
  { name: "Croatia", iso2: "HR", dialCode: "385", digits: 8 },
  { name: "Cuba", iso2: "CU", dialCode: "53", digits: 8 },
  { name: "Curaçao", iso2: "CW", dialCode: "599", digits: 7 },
  { name: "Cyprus", iso2: "CY", dialCode: "357", digits: 8 },
  { name: "Czech Republic", iso2: "CZ", dialCode: "420", digits: 9 },
  { name: "Côte d’Ivoire", iso2: "CI", dialCode: "225", digits: 8 },
  { name: "Denmark", iso2: "DK", dialCode: "45", digits: 8 },
  { name: "Djibouti", iso2: "DJ", dialCode: "253", digits: 8 },
  { name: "Dominica", iso2: "DM", dialCode: "1767", digits: 7 },
  { name: "Dominican Republic", iso2: "DO", dialCode: "1", digits: 10 },
  { name: "Ecuador", iso2: "EC", dialCode: "593", digits: 8 },
  { name: "Egypt", iso2: "EG", dialCode: "20", digits: 10 },
  { name: "El Salvador", iso2: "SV", dialCode: "503", digits: 8 },
  { name: "Equatorial Guinea", iso2: "GQ", dialCode: "240", digits: 9 },
  { name: "Eritrea", iso2: "ER", dialCode: "291", digits: 7 },
  { name: "Estonia", iso2: "EE", dialCode: "372", digits: 7 },
  { name: "Ethiopia", iso2: "ET", dialCode: "251", digits: 9 },
  { name: "Falkland Islands", iso2: "FK", dialCode: "500", digits: 5 },
  { name: "Faroe Islands", iso2: "FO", dialCode: "298", digits: 6 },
  { name: "Fiji", iso2: "FJ", dialCode: "679", digits: 7 },
  { name: "Finland", iso2: "FI", dialCode: "358", digits: 10 },
  { name: "France", iso2: "FR", dialCode: "33", digits: 9 },
  { name: "French Guiana", iso2: "GF", dialCode: "594", digits: 9 },
  { name: "French Polynesia", iso2: "PF", dialCode: "689", digits: 6 },
  { name: "French Southern and Antarctic Lands", iso2: "TF", dialCode: "262", digits: 9 },
  { name: "Gabon", iso2: "GA", dialCode: "241", digits: 7 },
  { name: "Gambia", iso2: "GM", dialCode: "220", digits: 7 },
  { name: "Georgia", iso2: "GE", dialCode: "995", digits: 9 },
  { name: "Germany", iso2: "DE", dialCode: "49", digits: 10 },
  { name: "Ghana", iso2: "GH", dialCode: "233", digits: 9 },
  { name: "Gibraltar", iso2: "GI", dialCode: "350", digits: 8 },
  { name: "Greece", iso2: "GR", dialCode: "30", digits: 10 },
  { name: "Greenland", iso2: "GL", dialCode: "299", digits: 6 },
  { name: "Grenada", iso2: "GD", dialCode: "1473", digits: 7 },
  { name: "Guadeloupe", iso2: "GP", dialCode: "590", digits: 9 },
  { name: "Guam", iso2: "GU", dialCode: "1671", digits: 7 },
  { name: "Guatemala", iso2: "GT", dialCode: "502", digits: 8 },
  { name: "Guernsey", iso2: "GG", dialCode: "44", digits: 10 },
  { name: "Guinea", iso2: "GN", dialCode: "224", digits: 8 },
  { name: "Guinea-Bissau", iso2: "GW", dialCode: "245", digits: 7 },
  { name: "Guyana", iso2: "GY", dialCode: "592", digits: 7 },
  { name: "Haiti", iso2: "HT", dialCode: "509", digits: 8 },
  { name: "Heard Island and McDonald Islands", iso2: "HM", dialCode: "672", digits: 6 },
  { name: "Honduras", iso2: "HN", dialCode: "504", digits: 8 },
  { name: "Hong Kong", iso2: "HK", dialCode: "852", digits: 8 },
  { name: "Hungary", iso2: "HU", dialCode: "36", digits: 9 },
  { name: "Iceland", iso2: "IS", dialCode: "354", digits: 7 },
  { name: "India", iso2: "IN", dialCode: "91", digits: 10 },
  { name: "Indonesia", iso2: "ID", dialCode: "62", digits: 7 },
  { name: "Iran", iso2: "IR", dialCode: "98", digits: 10 },
  { name: "Iraq", iso2: "IQ", dialCode: "964", digits: 10 },
  { name: "Ireland", iso2: "IE", dialCode: "353", digits: 9 },
  { name: "Isle of Man", iso2: "IM", dialCode: "44", digits: 10 },
  { name: "Israel", iso2: "IL", dialCode: "972", digits: 8 },
  { name: "Italy", iso2: "IT", dialCode: "39", digits: 9 },
  { name: "Jamaica", iso2: "JM", dialCode: "1876", digits: 7 },
  { name: "Japan", iso2: "JP", dialCode: "81", digits: 9 },
  { name: "Jersey", iso2: "JE", dialCode: "44", digits: 10 },
  { name: "Jordan", iso2: "JO", dialCode: "962", digits: 9 },
  { name: "Kazakhstan", iso2: "KZ", dialCode: "7", digits: 10 },
  { name: "Kenya", iso2: "KE", dialCode: "254", digits: 9 },
  { name: "Kiribati", iso2: "KI", dialCode: "686", digits: 5 },
  { name: "Kosovo", iso2: "XK", dialCode: "383", digits: 8 },
  { name: "Kuwait", iso2: "KW", dialCode: "965", digits: 8 },
  { name: "Kyrgyzstan", iso2: "KG", dialCode: "996", digits: 9 },
  { name: "Laos", iso2: "LA", dialCode: "856", digits: 8 },
  { name: "Latvia", iso2: "LV", dialCode: "371", digits: 8 },
  { name: "Lebanon", iso2: "LB", dialCode: "961", digits: 7 },
  { name: "Lesotho", iso2: "LS", dialCode: "266", digits: 8 },
  { name: "Liberia", iso2: "LR", dialCode: "231", digits: 8 },
  { name: "Libya", iso2: "LY", dialCode: "218", digits: 8 },
  { name: "Liechtenstein", iso2: "LI", dialCode: "423", digits: 10 },
  { name: "Lithuania", iso2: "LT", dialCode: "370", digits: 8 },
  { name: "Luxembourg", iso2: "LU", dialCode: "352", digits: 9 },
  { name: "Macau", iso2: "MO", dialCode: "853", digits: 8 },
  { name: "Macedonia", iso2: "MK", dialCode: "389", digits: 8 },
  { name: "Madagascar", iso2: "MG", dialCode: "261", digits: 9 },
  { name: "Malawi", iso2: "MW", dialCode: "265", digits: 9 },
  { name: "Malaysia", iso2: "MY", dialCode: "60", digits: 10 },
  { name: "Maldives", iso2: "MV", dialCode: "960", digits: 7 },
  { name: "Mali", iso2: "ML", dialCode: "223", digits: 8 },
  { name: "Malta", iso2: "MT", dialCode: "356", digits: 8 },
  { name: "Marshall Islands", iso2: "MH", dialCode: "692", digits: 7 },
  { name: "Martinique", iso2: "MQ", dialCode: "596", digits: 9 },
  { name: "Mauritania", iso2: "MR", dialCode: "222", digits: 8 },
  { name: "Mauritius", iso2: "MU", dialCode: "230", digits: 7 },
  { name: "Mayotte", iso2: "YT", dialCode: "262", digits: 9 },
  { name: "Mexico", iso2: "MX", dialCode: "52", digits: 8 },
  { name: "Micronesia", iso2: "FM", dialCode: "691", digits: 7 },
  { name: "Moldova", iso2: "MD", dialCode: "373", digits: 8 },
  { name: "Monaco", iso2: "MC", dialCode: "377", digits: 8 },
  { name: "Mongolia", iso2: "MN", dialCode: "976", digits: 8 },
  { name: "Montenegro", iso2: "ME", dialCode: "382", digits: 8 },
  { name: "Montserrat", iso2: "MS", dialCode: "1664", digits: 7 },
  { name: "Morocco", iso2: "MA", dialCode: "212", digits: 9 },
  { name: "Mozambique", iso2: "MZ", dialCode: "258", digits: 8 },
  { name: "Myanmar", iso2: "MM", dialCode: "95", digits: 6 },
  { name: "Namibia", iso2: "NA", dialCode: "264", digits: 9 },
  { name: "Nauru", iso2: "NR", dialCode: "674", digits: 7 },
  { name: "Nepal", iso2: "NP", dialCode: "977", digits: 8 },
  { name: "Netherlands", iso2: "NL", dialCode: "31", digits: 10 },
  { name: "New Caledonia", iso2: "NC", dialCode: "687", digits: 6 },
  { name: "New Zealand", iso2: "NZ", dialCode: "64", digits: 10 },
  { name: "Nicaragua", iso2: "NI", dialCode: "505", digits: 8 },
  { name: "Niger", iso2: "NE", dialCode: "227", digits: 8 },
  { name: "Nigeria", iso2: "NG", dialCode: "234", digits: 7 },
  { name: "Niue", iso2: "NU", dialCode: "683", digits: 4 },
  { name: "Norfolk Island", iso2: "NF", dialCode: "672", digits: 6 },
  { name: "North Korea", iso2: "KP", dialCode: "850", digits: 6 },
  { name: "Northern Mariana Islands", iso2: "MP", dialCode: "1670", digits: 7 },
  { name: "Norway", iso2: "NO", dialCode: "47", digits: 8 },
  { name: "Oman", iso2: "OM", dialCode: "968", digits: 8 },
  { name: "Pakistan", iso2: "PK", dialCode: "92", digits: 10 },
  { name: "Palau", iso2: "PW", dialCode: "680", digits: 7 },
  { name: "Palestine", iso2: "PS", dialCode: "970", digits: 9 },
  { name: "Panama", iso2: "PA", dialCode: "507", digits: 7 },
  { name: "Papua New Guinea", iso2: "PG", dialCode: "675", digits: 8 },
  { name: "Paraguay", iso2: "PY", dialCode: "595", digits: 9 },
  { name: "Peru", iso2: "PE", dialCode: "51", digits: 9 },
  { name: "Philippines", iso2: "PH", dialCode: "63", digits: 7 },
  { name: "Pitcairn Islands", iso2: "PN", dialCode: "64", digits: 6 },
  { name: "Poland", iso2: "PL", dialCode: "48", digits: 9 },
  { name: "Portugal", iso2: "PT", dialCode: "351", digits: 9 },
  { name: "Puerto Rico", iso2: "PR", dialCode: "1", digits: 10 },
  { name: "Qatar", iso2: "QA", dialCode: "974", digits: 8 },
  { name: "Romania", iso2: "RO", dialCode: "40", digits: 9 },
  { name: "Russia", iso2: "RU", dialCode: "7", digits: 10 },
  { name: "Rwanda", iso2: "RW", dialCode: "250", digits: 9 },
  { name: "Réunion", iso2: "RE", dialCode: "262", digits: 9 },
  { name: "Saint Barthélemy", iso2: "BL", dialCode: "590", digits: 9 },
  { name: "Saint Helena", iso2: "SH", dialCode: "290", digits: 4 },
  { name: "Saint Kitts and Nevis", iso2: "KN", dialCode: "1869", digits: 7 },
  { name: "Saint Lucia", iso2: "LC", dialCode: "1758", digits: 7 },
  { name: "Saint Martin", iso2: "MF", dialCode: "590", digits: 9 },
  { name: "Saint Pierre and Miquelon", iso2: "PM", dialCode: "508", digits: 6 },
  { name: "Saint Vincent and the Grenadines", iso2: "VC", dialCode: "1784", digits: 7 },
  { name: "Samoa", iso2: "WS", dialCode: "685", digits: 6 },
  { name: "San Marino", iso2: "SM", dialCode: "378", digits: 10 },
  { name: "Saudi Arabia", iso2: "SA", dialCode: "966", digits: 9 },
  { name: "Senegal", iso2: "SN", dialCode: "221", digits: 9 },
  { name: "Serbia", iso2: "RS", dialCode: "381", digits: 9 },
  { name: "Seychelles", iso2: "SC", dialCode: "248", digits: 7 },
  { name: "Sierra Leone", iso2: "SL", dialCode: "232", digits: 8 },
  { name: "Singapore", iso2: "SG", dialCode: "65", digits: 8 },
  { name: "Sint Maarten", iso2: "SX", dialCode: "1721", digits: 7 },
  { name: "Slovakia", iso2: "SK", dialCode: "421", digits: 9 },
  { name: "Slovenia", iso2: "SI", dialCode: "386", digits: 8 },
  { name: "Solomon Islands", iso2: "SB", dialCode: "677", digits: 5 },
  { name: "Somalia", iso2: "SO", dialCode: "252", digits: 7 },
  { name: "South Africa", iso2: "ZA", dialCode: "27", digits: 9 },
  { name: "South Georgia and the South Sandwich Islands", iso2: "GS", dialCode: "500", digits: 5 },
  { name: "South Korea", iso2: "KR", dialCode: "82", digits: 9 },
  { name: "South Sudan", iso2: "SS", dialCode: "211", digits: 9 },
  { name: "Spain", iso2: "ES", dialCode: "34", digits: 9 },
  { name: "Sri Lanka", iso2: "LK", dialCode: "94", digits: 9 },
  { name: "Sudan", iso2: "SD", dialCode: "249", digits: 9 },
  { name: "Suriname", iso2: "SR", dialCode: "597", digits: 6 },
  { name: "Svalbard and Jan Mayen", iso2: "SJ", dialCode: "47", digits: 8 },
  { name: "Swaziland", iso2: "SZ", dialCode: "268", digits: 8 },
  { name: "Sweden", iso2: "SE", dialCode: "46", digits: 9 },
  { name: "Switzerland", iso2: "CH", dialCode: "41", digits: 9 },
  { name: "Syria", iso2: "SY", dialCode: "963", digits: 9 },
  { name: "São Tomé and Príncipe", iso2: "ST", dialCode: "239", digits: 7 },
  { name: "Taiwan", iso2: "TW", dialCode: "886", digits: 8 },
  { name: "Tajikistan", iso2: "TJ", dialCode: "992", digits: 9 },
  { name: "Tanzania", iso2: "TZ", dialCode: "255", digits: 9 },
  { name: "Thailand", iso2: "TH", dialCode: "66", digits: 8 },
  { name: "Timor-Leste", iso2: "TL", dialCode: "670", digits: 7 },
  { name: "Togo", iso2: "TG", dialCode: "228", digits: 8 },
  { name: "Tokelau", iso2: "TK", dialCode: "690", digits: 4 },
  { name: "Tonga", iso2: "TO", dialCode: "676", digits: 5 },
  { name: "Trinidad and Tobago", iso2: "TT", dialCode: "1868", digits: 7 },
  { name: "Tunisia", iso2: "TN", dialCode: "216", digits: 8 },
  { name: "Turkey", iso2: "TR", dialCode: "90", digits: 10 },
  { name: "Turkmenistan", iso2: "TM", dialCode: "993", digits: 8 },
  { name: "Turks and Caicos Islands", iso2: "TC", dialCode: "1649", digits: 7 },
  { name: "Tuvalu", iso2: "TV", dialCode: "688", digits: 5 },
  { name: "U.S. Virgin Islands", iso2: "VI", dialCode: "1340", digits: 7 },
  { name: "Uganda", iso2: "UG", dialCode: "256", digits: 9 },
  { name: "Ukraine", iso2: "UA", dialCode: "380", digits: 9 },
  { name: "United Arab Emirates", iso2: "AE", dialCode: "971", digits: 8 },
  { name: "United Kingdom", iso2: "GB", dialCode: "44", digits: 10 },
  { name: "United States", iso2: "US", dialCode: "1", digits: 10 },
  { name: "United States Minor Outlying Islands", iso2: "UM", dialCode: "1", digits: 10 },
  { name: "Uruguay", iso2: "UY", dialCode: "598", digits: 8 },
  { name: "Uzbekistan", iso2: "UZ", dialCode: "998", digits: 9 },
  { name: "Vanuatu", iso2: "VU", dialCode: "678", digits: 5 },
  { name: "Vatican City", iso2: "VA", dialCode: "39", digits: 10 },
  { name: "Venezuela", iso2: "VE", dialCode: "58", digits: 10 },
  { name: "Vietnam", iso2: "VN", dialCode: "84", digits: 9 },
  { name: "Wallis and Futuna", iso2: "WF", dialCode: "681", digits: 6 },
  { name: "Western Sahara", iso2: "EH", dialCode: "212", digits: 6 },
  { name: "Yemen", iso2: "YE", dialCode: "967", digits: 7 },
  { name: "Zambia", iso2: "ZM", dialCode: "260", digits: 9 },
  { name: "Zimbabwe", iso2: "ZW", dialCode: "263", digits: 7 },
  { name: "Åland Islands", iso2: "AX", dialCode: "358", digits: 9 },
];

// Converts an ISO 3166-1 alpha-2 code (e.g. 'IN') into its flag emoji (🇮🇳)
// using regional indicator symbols, so we don't need to store/maintain emoji.
export function flagEmoji(iso2: string): string {
  return iso2
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

// Convenience lookup: dial code -> matching countries (some dial codes, like
// '+1' for NANP, are shared by many countries/territories).
export function countriesForDialCode(dialCode: string): CountryPhoneInfo[] {
  return COUNTRIES.filter((c) => c.dialCode === dialCode);
}